import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { getStageAttempts } from '../services/run-detail.service';

/**
 * Every attempt of one stage, read only when a stages-table row is expanded
 * (`enabled`) so the overview does not fan out one call per stage.
 */
export function useRunStageAttempts(runRef: string, stage: string, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.catalogService.runStageAttempts(runRef, stage),
    queryFn: () => getStageAttempts(runRef, stage),
    enabled: enabled && !!runRef && !!stage,
  });
}
